import React, { useMemo } from "react";
import classes from "./tableSkeleton.module.css";

export const TableSkeleton = ({
  columns = [],
  rows = 6,
  mobileHiddenColumns = [],
}) => {
  // Generate stable random widths once
  const skeletonWidths = useMemo(() => {
    return Array.from({ length: rows }).map(() =>
      columns.map(() => `${60 + Math.random() * 40}%`)
    );
  }, [rows, columns.length]);

  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <tr key={rowIndex}>
          {columns.map((column, colIndex) => {
            const hideClass = mobileHiddenColumns.includes(column.id)
              ? classes.hideMobile
              : "";

            return (
              <td
                key={colIndex}
                className={`${classes.cell} ${hideClass}`}
              >
                <div
                  className={classes.skeleton}
                  style={{ width: skeletonWidths[rowIndex][colIndex] }}
                />
              </td>
            );
          })}
        </tr>
      ))}
    </>
  );
};